export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14611.c4e8b5ad.jpg";